import z from 'zod';

export const visualSettingsSchema = z.object({
	userMetrics: z.boolean(),
	dailyUsersChart: z.boolean(),
	complianceSection: z.boolean(),
	eventOverviewSection: z.boolean(),
	inhoudingsplicht: z.boolean(),
});

export const adminExperienceSchema = z.enum(['legacy', '2.0']);

export const userPreferenceSchema = z.object({
	isMainDrawerOpen: z.boolean().optional(),
	isSideDrawerOpen: z.number().optional(),
	selectedSiteId: z.string().optional(),
	visualSettings: visualSettingsSchema.optional(),
	companyPortalActiveGroupId: z.string().optional(),
	partnerPortalActiveGroupId: z.string().optional(),
	supervisorPortalActiveGroupId: z.string().optional(),
	adminExperience: adminExperienceSchema.optional(),
	/** Keys of first-use guides the user has dismissed ("don't show again"), e.g. "employee.firstUse". */
	dismissedGuides: z.array(z.string()).optional(),
});
